import MuiTooltip, { type TooltipProps } from '@mui/material/Tooltip';

export type { TooltipProps };

const Tooltip = (props: TooltipProps) => <MuiTooltip {...props} />;

export default Tooltip;
